import { useTranslation } from 'react-i18next'
import { Section } from '#app/ui/components/custom/section'
import { SectionHeader } from '#app/ui/components/custom/section-header'
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '#app/ui/components/disclosure/accordion'
import { A } from '#app/ui/components/typography/a'
import { P } from '#app/ui/components/typography/p'

type FaqItem = { question: string; answer: string[] }

export const FAQ = () => {
	const { t } = useTranslation('home')
	const faqs = t('faq.items', { returnObjects: true }) as FaqItem[]

	return (
		<Section>
			<SectionHeader
				align="center"
				eyebrow={t('faq.eyebrow')}
				heading={t('faq.heading')}
			/>
			<Accordion
				type="single"
				collapsible
				className="mx-auto mt-fluid-16 w-full max-w-3xl border-t border-hairline"
			>
				{faqs.map((faq, index) => (
					<AccordionItem
						key={faq.question}
						value={`item-${index}`}
						className="border-b border-hairline"
					>
						<AccordionTrigger className="py-5 text-left text-base font-medium hover:no-underline">
							{faq.question}
						</AccordionTrigger>
						<AccordionContent className="pb-5">
							{faq.answer.map(paragraph => (
								<P key={paragraph} className="text-sm text-muted-600">
									{paragraph}
								</P>
							))}
						</AccordionContent>
					</AccordionItem>
				))}
			</Accordion>
			<p className="mx-auto mt-fluid-12 max-w-3xl text-sm text-muted-500">
				{t('faq.moreBefore')} <A href="/call">{t('faq.moreLink')}</A>{' '}
				{t('faq.moreAfter')}
			</p>
		</Section>
	)
}
